import { entityScripts } from "@/lib/entityJsonLd";
import { createFileRoute, notFound } from "@tanstack/react-router";
import NotFound from "@/pages/NotFound";
import GuideDetail from "@/pages/GuideDetail";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta, readable } from "@/lib/routeSocial";
import { findGuide } from "@/lib/seoClusters";

export const Route = createFileRoute("/guides/$slug")({
  beforeLoad: ({ params }) => {
    if (!findGuide(params.slug)) throw notFound();
  },
  notFoundComponent: NotFound,
  head: ({ params }) => {
    const guide = findGuide(params.slug);
    return {
      scripts: entityScripts({ type: "Article", name: (guide?.title ?? readable(params.slug)), path: `/guides/${params.slug}`, crumbs: [{ name: "Guides", path: "/guides" }, { name: guide?.title ?? readable(params.slug), path: `/guides/${params.slug}` }], extra: { headline: guide?.title ?? readable(params.slug), author: { "@type": "Organization", name: "Statlign" }, publisher: { "@id": "https://statlign.com/#organization" } } }),
      meta: socialMeta({
        seo: { topics: ["guides"] },
        title: guide?.title ?? `${readable(params.slug)} | Statlign Betting Guides`,
        description:
          guide?.description ??
          "Plain-English betting guides from Statlign covering odds, value, staking and bankroll management.",
        ogType: "article",
      }),
    };
  },
  component: () => (
    <MainLayout>
      <GuideDetail />
    </MainLayout>
  ),
});
